module.exports = __webpack_public_path__ + "img/523683256.dfbfe41a.svg";